import { LoadingIndicator, Text } from "@/components";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

import { jobPauseTypeToLabel } from "@/lib/constants";
import { JobPauseType } from "@/types";

// Moving a candidacy up the pipeline on a parked job is a signal the job is
// live again, so the move stops to ask. Closing without choosing cancels the
// move outright.
export const PausedJobMoveDialog = ({
  isLoading,
  onKeepParked,
  onMoveAndActivate,
  onOpenChange,
  open,
  pauseType,
}: {
  isLoading?: boolean;
  onKeepParked: () => void;
  onMoveAndActivate: () => void;
  onOpenChange: (open: boolean) => void;
  open: boolean;
  pauseType: JobPauseType;
}) => {
  const pauseLabel = jobPauseTypeToLabel[pauseType].toLowerCase();

  const render = () => (
    <Dialog onOpenChange={onOpenChange} open={open}>
      <DialogContent className="flex max-w-2xl flex-col gap-6">
        <DialogHeader className="flex flex-col gap-4">
          <DialogTitle className="text-2xl font-semibold text-slate-700">
            {`This job is ${pauseLabel}`}
          </DialogTitle>
          <Text className="!m-0 text-base font-medium text-slate-700">
            Would you like to mark the job active again?
          </Text>
        </DialogHeader>
        <DialogFooter>
          <Button
            className="rounded-full"
            disabled={isLoading}
            onClick={onKeepParked}
            type="button"
            variant="secondary"
          >
            {`Move candidacy but keep job ${pauseLabel}`}
          </Button>
          <Button
            className="rounded-full"
            disabled={isLoading}
            onClick={onMoveAndActivate}
            type="button"
          >
            {isLoading ? (
              <LoadingIndicator gearColor="white" variant="small" />
            ) : (
              <span>Move candidacy and mark active</span>
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );

  return render();
};
